import React from "react";
import PropTypes from "prop-types";
import { IonButton } from "@ionic/react";

function ServingPlayerResult({ servingPlayer, onAction }) {
  return (
    <div
      className="ServingPlayerResult"
      style={{
        display: "flex",
        flexDirection: "column",
        marginBottom: "10px",
        flex: 1,
      }}
    >
      <b>{servingPlayer.name}</b>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
        }}
      >
        <IonButton
          size="large"
          expand="full"
          color={"success"}
          onClick={() =>
            onAction("winner", {
              athleteId: servingPlayer.athleteId,
              mode: "service",
            })
          }
        >
          Servizio Vincente
        </IonButton>
        <IonButton
          size="large"
          expand="full"
          onClick={() =>
            onAction("start_rally", { athleteId: servingPlayer.athleteId })
          }
        >
          Inizia lo scambio
        </IonButton>
      </div>
    </div>
  );
}

ServingPlayerResult.propTypes = {
  servingPlayer: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default ServingPlayerResult;
